/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discover_CreatorsInputs */

const en_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover creators`)
};

const es_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubrir creadores`)
};

const fr_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrir des créateurs`)
};

const de_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator entdecken`)
};

const ja_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリエイターを発見する`)
};

const zh_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现创作者`)
};

const ar_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتشف المبدعين`)
};

const id_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temukan kreator`)
};

const it_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoprire creatori`)
};

const ru_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найти авторов`)
};

const pt_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descobrir criadores`)
};

const ko_discover_creators = /** @type {(inputs: Discover_CreatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리에이터 발견`)
};

/**
* | output |
* | --- |
* | "Discover creators" |
*
* @param {Discover_CreatorsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const discover_creators = /** @type {((inputs?: Discover_CreatorsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discover_CreatorsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_discover_creators(inputs)
	if (locale === "es") return es_discover_creators(inputs)
	if (locale === "fr") return fr_discover_creators(inputs)
	if (locale === "de") return de_discover_creators(inputs)
	if (locale === "ja") return ja_discover_creators(inputs)
	if (locale === "zh") return zh_discover_creators(inputs)
	if (locale === "ar") return ar_discover_creators(inputs)
	if (locale === "id") return id_discover_creators(inputs)
	if (locale === "it") return it_discover_creators(inputs)
	if (locale === "ru") return ru_discover_creators(inputs)
	if (locale === "pt") return pt_discover_creators(inputs)
	return ko_discover_creators(inputs)
});